import '../App.css'
import { useEffect, useState } from 'react';
import api from '../config/api';

function PrivacyPolicy() {
  const [authorDetails, setAuthorDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load author details from API
    const fetchAuthorDetails = async () => {
      try {
        const response = await api.get('/author-details');
        if (response.data.success && response.data.data) {
          setAuthorDetails(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching author details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAuthorDetails();
  }, []);

  const renderAuthorDetails = () => {
    if (loading) {
      return <p>Loading author information...</p>;
    }

    if (!authorDetails || !authorDetails.name) {
      return <p>No author information available.</p>;
    }

    return (
      <div className="author-info">
        <h3>{authorDetails.name}</h3>
        {authorDetails.profile_image && (
          <img 
            src={`${api.defaults.baseURL?.replace('/api', '') || 'http://127.0.0.1:8000'}/storage/${authorDetails.profile_image}`} 
            alt={authorDetails.name} 
            className="img-thumbnail mb-3" 
            style={{ maxWidth: '200px', height: 'auto' }}
          />
        )}
        {authorDetails.bio && (
          <p className="author-bio">{authorDetails.bio}</p>
        )}
        <div className="author-contact mt-3">
          {authorDetails.email && (
            <p>Email: <a href={`mailto:${authorDetails.email}`}>{authorDetails.email}</a></p>
          )}
          <div className="author-social-links mt-2">
            {authorDetails.social_links?.twitter && (
              <a href={authorDetails.social_links.twitter} target="_blank" rel="noopener noreferrer" className="me-3">Twitter</a>
            )}
            {authorDetails.social_links?.linkedin && (
              <a href={authorDetails.social_links.linkedin} target="_blank" rel="noopener noreferrer" className="me-3">LinkedIn</a>
            )}
            {authorDetails.social_links?.website && (
              <a href={authorDetails.social_links.website} target="_blank" rel="noopener noreferrer">Website</a>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <section className="page-section">
      <div className="container">
        <div className="page-content" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
          <h1 className="page-title">Privacy Policy</h1>
          
          <div className="policy-content">
            <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '1rem' }}>
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <div className="policy-section">
              <h2>1. Introduction</h2>
              <p>
                SkillSiksha ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. Information We Collect</h2>
              <p>We may collect information about you in a variety of ways:</p>
              <ul className="policy-list">
                <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details when you use our contact forms.</li>
                <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, and device information.</li>
                <li><strong>Cookies:</strong> We may use cookies and similar tracking technologies to track activity on our website and store certain information.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>3. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="policy-list">
                <li>Provide, maintain, and improve our services</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Send you updates and notifications about government job opportunities</li>
                <li>Analyze usage patterns to enhance user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. Third-Party Services</h2>
              <p>
                We may use third-party service providers to help us operate our website and administer activities on our behalf. These third parties may have access to your information only to perform specific tasks and are obligated not to disclose or use it for any other purpose.
              </p>
            </div>

            <div className="policy-section">
              <h2>6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="policy-list">
                <li>Access and receive a copy of your personal data</li>
                <li>Rectify inaccurate or incomplete data</li>
                <li>Request deletion of your personal data</li>
                <li>Object to processing of your personal data</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>7. Cookies Policy</h2>
              <p>
                Our website uses cookies to enhance user experience. You can choose to disable cookies through your browser settings, but this may affect your ability to access certain features of our website.
              </p>
            </div>

            <div className="policy-section">
              <h2>8. Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </div>

            <div className="policy-section">
              <h2>9. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <ul className="policy-list">
                <li>Email: Prabhumeena3167@gmail.com</li>
                <li>Phone: +918290114167</li>
                <li>Address: Udaipur, India</li>
              </ul>
            </div>


          </div>

          {/* Author Details Section */}
          <div className="policy-section mt-5 pt-4" style={{ borderTop: '1px solid #eee' }}>
            <h2>About the Author</h2>
            <div id="author-details-container">
              {renderAuthorDetails()}
            </div>
          </div>
        </div>
      </div>
  </section>
  )
}

export default PrivacyPolicy

